import { availableLanguages } from '@/i18n'


export default {
    data() {
        return {
            lang: { value: 'nl-BE', label: this.$t('languages.nl-BE') }
        }
    },
    methods: {
        setLanguage(lang) {
            localStorage.setItem('sts-lang', lang);
            this.lang = this.languages.find(l => l.value === lang)
        }
    },

    computed: {
        languages() {
            return availableLanguages.map(language => ({ value: language, label: this.$t(`languages.${language}`) }))
        }
    },
}
